import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {updatesData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">{updatesData.subtitle}</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden sm:block"></div>

          <div className="flex flex-col gap-5">
            {updatesData.items.map((item, idx) => (
              <div key={idx} className="flex gap-5 items-start">
                <div className="hidden sm:flex w-10 h-10 rounded-full bg-primary-100 border-2 border-background-50 flex-shrink-0 items-center justify-center relative z-10 mt-0.5">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                </div>
                <div className="flex-1 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60">
                  <span className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full mb-2">
                    {item.date}
                  </span>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}